import { render } from "./ResetLinkView.vue?vue&type=template&id=34737f98&ts=true"
import script from "./ResetLinkView.vue?vue&type=script&lang=ts"
export * from "./ResetLinkView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__